import { apiConfig } from 'config';
import { handle420 } from 'apis/HandleError';

export function deleteSoftware(swIdentifier) {
  const auth = window.__APP_AUTH;
  const headers = {
    Accept: '*/*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
  };

  const url = apiConfig.swManagerSoftwareDelete(swIdentifier);

  console.log('deleting', swIdentifier);
  return fetch(url, { method: 'DELETE', headers: headers })
    .then((response) => {
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      return response;
    })
    .catch((e) => {
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          console.log(e);
          throw Error('delete Software Failed');
      }
    });
}
